module.exports = __webpack_public_path__ + "static/media/medappupdated.3e0cc6b6.PNG";